var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticStyle: { width: "100%" },
    attrs: {
      "fixed-header": "",
      items: _vm.maps,
      headers: _vm.headers,
      "hide-default-footer": "",
      "disable-pagination": "",
    },
    scopedSlots: _vm._u([
      {
        key: "item.name",
        fn: function ({ item }) {
          return [
            _c("div", { staticClass: "blue--text" }, [
              _vm._v(_vm._s(item.name)),
            ]),
          ]
        },
      },
      {
        key: "item.owner",
        fn: function ({ item }) {
          return [_c("div", [_vm._v(_vm._s(_vm.getUserName(item)))])]
        },
      },
      {
        key: "item.checksum",
        fn: function ({ item }) {
          return [_c("div", [_vm._v(_vm._s(item.checksum))])]
        },
      },
      {
        key: "item.created",
        fn: function ({ item }) {
          return [
            _c("div", { staticClass: "text-no-wrap" }, [
              _vm._v(_vm._s(_vm._f("formatDate")(item.created))),
            ]),
          ]
        },
      },
      {
        key: "item.aud",
        fn: function ({ item }) {
          return [
            _c(
              "v-btn",
              {
                staticClass: "mr-1",
                attrs: {
                  disabled: !_vm.ifCanEditAudience(),
                  outlined: "",
                  color: "orange",
                },
                on: {
                  click: function ($event) {
                    return _vm.onPressEditAudience(item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.aud) + " ")]
            ),
          ]
        },
      },
      {
        key: "item.version",
        fn: function ({ item }) {
          return [
            _c(
              "v-btn",
              {
                staticClass: "mr-1",
                attrs: {
                  disabled: !_vm.ifCanEditVersion(),
                  outlined: "",
                  color: "green",
                },
                on: {
                  click: function ($event) {
                    return _vm.onPressEditVersion(item)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.minver || "-") +
                    " - " +
                    _vm._s(item.maxver || "-") +
                    " "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "item.custom_name",
        fn: function ({ item }) {
          return [
            _c(
              "v-btn",
              {
                staticClass: "mr-1",
                attrs: { outlined: "", color: "light-blue" },
                on: {
                  click: function ($event) {
                    return _vm.onPressEditCustomName(item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.custom_name) + " ")]
            ),
          ]
        },
      },
      {
        key: "item.actions",
        fn: function ({ item }) {
          return [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        disabled: !_vm.ifCanExport(),
                                        loading: _vm.exporting(item.id),
                                        icon: "",
                                        color: "green",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressExport(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-download"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Export map")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        disabled: !_vm.ifCanDublicate(),
                                        loading: _vm.dublicating(item.id),
                                        icon: "",
                                        color: "orange",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDublicate(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "19" } }, [
                                    _vm._v("mdi-file-multiple-outline"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Dublicate map")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        disabled: !_vm.ifCanDelete(),
                                        loading: _vm.deleting(item.id),
                                        icon: "",
                                        color: "red",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDelete(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-delete"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Delete map")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        disabled: !_vm.ifCanAddToDeploy(),
                                        icon: "",
                                        color: "blue",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressAddToDeploy(
                                            item.name
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-folder-plus"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Add to deploy")])]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }